let update_cart_trigger = null;

export function mini_cart_refresh(count) {
    const mini_cart = jQuery('[data-mini-cart]');
    mini_cart.find('[data-mini-cart-total]').text(count);
    if (count) {
        mini_cart.removeClass('hidden');
    } else {
        mini_cart.addClass('hidden');
    }
}

export function get_notices(action_notices) {
    if (!action_notices) return;
    jQuery.ajax({
        url:
            wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'get_notices') +
            `&${action_notices}=1`,
        type: 'GET',
        timeout: wc_add_to_cart_params.request_timeout,

        success: function (data) {
            if (data && data.notices) {
                notices_add(data.notices);

                mini_cart_refresh(data.cart_count);

                jQuery(document.body).trigger('wc_notices_refreshed');
            }
        },
        error: function () {
            jQuery(document.body).trigger('wc_notices_ajax_error');
        }
    });
}

export function notices_add(notices) {
    if (!notices) return;

    const notices_block = jQuery('.woocommerce-notices-wrapper');
    const current_notice = jQuery(notices);

    notices_block.prepend(current_notice);

    notices_block.show();

    notices_remove(current_notice);
}

export function notices_remove(notice = false) {
    const notices_block = jQuery('.woocommerce-notices-wrapper');

    if (!notices_block.children().length) {
        notices_block.hide();
    } else {
        setTimeout(() => {
            if (notice) {
                notices_block.find(notice).remove();
            } else {
                notices_block.children().remove();
            }
            if (!notices_block.children().length) notices_block.hide();
        }, 5000);
    }
}

export function handleClickAddProductCart(event) {
    event.preventDefault();

    const product = event.target.closest('[data-product]') ?? null;

    if (!product) return;

    const product_id = Number(product.dataset.product) || 0;

    const data = {
        product_id,
        quantity: 1
    };

    jQuery.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: data,
        dataType: 'json',
        beforeSend: function () {
            jQuery(product).addClass('loading');
        },
        complete: function () {
            jQuery(product).removeClass('loading');
        },
        success: function (res) {
            get_notices('add_to_cart');
            if (!res.error) {
                jQuery(document.body).trigger('added_to_cart', [res.fragments, res.cart_hash]);
                jQuery(product).trigger('add_product_to_cart', [product]);
                jQuery(product).addClass('in_cart');
            }
        }
    });
}

export function handleClickRemoveProductCart(event) {
    event.preventDefault();
    const product = event.target.closest('[data-product]') ?? null;
    const cart_item_key = event.target.dataset.productChangeCart ?? null;

    if (!product || !cart_item_key) return;

    jQuery.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
        data: { cart_item_key },
        dataType: 'json',
        beforeSend: function () {
            jQuery(product).addClass('loading');
        },
        complete: function () {
            jQuery(product).removeClass('loading');
        },
        success: function (res) {
            get_notices('remove_from_cart');
            if (!res.error) {
                jQuery(product).removeClass('in_cart');
            }
        }
    });
}

export function updateCart() {
    if (update_cart_trigger) {
        clearTimeout(update_cart_trigger);
    }

    update_cart_trigger = setTimeout(() => {
        update_cart_trigger = null;
        jQuery('[name="update_cart"]').trigger('click');
    }, 1500);
}

export function handleClickProductChangeQuantity(e) {
    const input = jQuery(e.target).parent('[data-quantity]').find('.qty');
    let value = Number(input.val());
    const action = e.target.dataset.quantity;
    const newValue = action === 'plus' ? ++value : --value;
    const max = Number(input.attr('max'));

    if (max && newValue > max) return;
    if (newValue < 0) return;
    input.val(newValue);
    input.trigger('change');
}

export function initMiniCart() {
    jQuery(document.body).on({
        added_to_cart: updateMiniCart,
        removed_from_cart: updateMiniCart,
        updated_cart_totals: updateMiniCart
    });

    updateMiniCart();
}

export function updateMiniCart() {
    const $miniCart = jQuery('[data-mini-cart]');
    if (!$miniCart.length) return;

    const count = getCartCount();
    $miniCart.find('[data-mini-cart-total]').text(count);
    $miniCart.toggleClass('hidden', count <= 0);
}

jQuery(document).ready(function () {
    updateMiniCart();

    jQuery(document.body).on('added_to_cart removed_from_cart updated_cart_totals', function () {
        updateMiniCart();
    });
});

export function getCartCount() {
    const countEl = document.querySelector('[data-mini-cart-total]');
    if (countEl) {
        const count = parseInt(countEl.textContent);
        if (!isNaN(count)) return count;
    }

    if (typeof wc_add_to_cart_params !== 'undefined') {
        return jQuery('[data-mini-cart-total]').data('count') || 0;
    }

    return 0;
}

jQuery(document).ready(function () {
    initMiniCart();
});
